import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ProductService } from 'src/app/services/core/services/product-services/product.service';
import { onTimeChange } from 'src/app/utils/utils.common';
import * as moment from 'moment-timezone';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductType } from '../../../utils/utils.common';
import { sweetAlert } from 'src/app/utils/swal';


@UntilDestroy()

@Component({
  selector: 'app-add-product-service',
  templateUrl: './add-product-service.component.html',
  styleUrls: ['./add-product-service.component.css']
})
export class AddProductServiceComponent implements OnInit {
  submitted = false;
  productServiceForm!: FormGroup;
  user: any;
  accountDetail: any;
  selectedCompany: any = '';
  companies: any;
  productId:any;
  ProductType = ProductType;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private companyService: CompanyService,
    private sharedDataService: SharedDataService,
    private productService: ProductService,
    private fb: FormBuilder) { }

  ngOnInit(): void {
    console.log('ProductType', ProductType);
      this.activatedRoute.params
      .pipe(untilDestroyed(this)).subscribe((params) => {
        this.productId = params["id"];
        if (this.productId) {
          this.getProductbyId();
        }
      }
    );
    this.getCompanies();
    this.productServiceForm = this.fb.group({
      Name: ['', Validators.required],
      Type: [{ value: 'Service'}, Validators.required],
      QtyOnHand: [0, Validators.required],
      UnitPrice: [0, Validators.required],
      Description: [''],
      IncomeAccountRef: this.fb.group({
        value: ['', Validators.required]
      }),
      reference: this.fb.group({
        name: [''],
        id: [''],
        priority: ['']

      }),
      Active:[true]
    });
    this.getUser();
  }

   get form() {
    return this.productServiceForm.controls;
  }

  get incomeAccountRef() {
    return (this.productServiceForm.get('IncomeAccountRef') as FormGroup).controls;
  }

  get reference(){
    return (this.productServiceForm.get('reference') as FormGroup).controls
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.productServiceForm.patchValue({
          InvStartDate: moment().tz(this.user.timeZone).toISOString(),
        })
      }
    })
  }


  getCompanies() {
    this.companyService.getCompanies({ status: 'created' }).subscribe((data: any) => {
      if (data) {
        this.companies = data.results

      }
    })
  }

  onCompanyChange() {
    if (this.selectedCompany) {
      this.getAccountDetail();
    }
  }

   getProductbyId() {
    this.productService.getProductServiceById(this.productId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.productServiceForm.patchValue({
          ...data,
        //   IncomeAccountRef: {
        //   value: data.IncomeAccountRef.value
        // }
        })
        this.selectedCompany = data.company;
        this.getAccountDetail();
     
      }
    })
  }

  // onDateChange(controlName: AbstractControl<any, any> | null) {
  //   onTimeChange(controlName)
  // }

  onSave() {
    this.submitted = true
    if (this.productServiceForm.invalid) return;
    let payload = this.productServiceForm.value;
    payload = {
      ...this.productServiceForm.value,
      company: this.selectedCompany
    }
    this.productService.saveProductService(this.productId, payload).subscribe({
      next: (data: any) => {
        if (data) {
          this.router.navigateByUrl('/services')
        }
      },
      error: (err) => {
        sweetAlert("Error", err, "error", "Ok");
      },
      complete: () => {
        console.log("services save completed");
      }
    })
  }


  getAccountDetail() {
    this.productService.getAccount(this.selectedCompany).subscribe((data: any) => {
      if (data) {
        this.accountDetail = data
      }
    })
  }

  toggleActive(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.productServiceForm.patchValue({
      Active: isChecked,
    });
  }
}
